"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pregnana-milanese": {
    "d4427a21": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "skipSearch": false
    }],
    "cascine-serbelloni": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "160b3617": [{
      "hkey": "8f7b6658",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "comune": [{
      "hkey": "8f7b6658",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3c12a274": [{
      "hkey": "dfcfc451",
      "slug": "cascina-duomo",
      "name": "Cascina Duomo",
      "primary": true,
      "skipSearch": false
    }],
    "duomo": [{
      "hkey": "dfcfc451",
      "slug": "cascina-duomo",
      "name": "Cascina Duomo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "84d898e2": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "skipSearch": false
    }],
    "isola-maddalena": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b18013a8": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "skipSearch": false
    }],
    "madonnina": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "34706f97": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "skipSearch": false
    }],
    "molino-cecchetti": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "10aa90ea": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "skipSearch": false
    }],
    "orombella": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "09ce1fcf": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "d00b86d3",
      "slug": "pregnana-milanese",
      "name": "Pregnana Milanese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;